import { EXPIRATION_PERIOD, FORM_FREQUENCY } from 'settings/consultation-forms/consultationForms.const';

/** Clears expiry when frequency is every appointment — expiry does not apply in that case. */
export const sanitizeConsultationFormRules = (rules) => {
  if (rules?.frequency !== FORM_FREQUENCY.EVERY_APPOINTMENT) {
    return rules;
  }

  return { ...rules, expiration_period: EXPIRATION_PERIOD.NEVER };
};
